import type React from 'react'
import type { IconProps } from './types'

const ChevDownIcon: React.FC<IconProps> = ({ size = 20, className = 'text-neutral-900', style }) => (
	<svg
		width={size}
		height={size}
		style={style}
		viewBox='0 0 24 24'
		className={className}
		fill='currentColor'
		xmlns='http://www.w3.org/2000/svg'
		aria-hidden='true'>
		<path d='M4 9.4202L5.42 8.0002L12 14.5802L18.58 8.0002L20 9.4202L12 17.4202L4 9.4202Z' />
	</svg>
)

export default ChevDownIcon
